import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useT } from "../lib/i18n";
import { toast } from "sonner";
import { HERO_BG } from "../lib/shop";

export default function Login() {
  const { login } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(t("auth.welcomeback"));
      nav(loc.state?.from || (u.role === "admin" ? "/admin" : "/cont"));
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : t("auth.signin.error"));
    } finally { setLoading(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-[calc(100vh-5rem)]" data-testid="login-page">
      <div className="hidden lg:block relative overflow-hidden bg-silver-shimmer">
        <img src={HERO_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-gray-900">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-500">ANAIZA · SHOP</p>
          <p className="font-display text-3xl font-black tracking-tighter mt-3 leading-tight">{t("auth.hero.signin")}</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-400">{t("auth.signin.eye")}</p>
          <h1 className="font-display text-4xl font-black tracking-tighter mt-3">{t("auth.signin.title")}</h1>

          <div className="mt-10 space-y-6">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-2">{t("auth.email")}</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full border-b border-gray-300 bg-transparent py-2 focus:border-gray-900 focus:outline-none" data-testid="login-email" />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-2">{t("auth.password")}</label>
              <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full border-b border-gray-300 bg-transparent py-2 focus:border-gray-900 focus:outline-none" data-testid="login-password" />
            </div>
          </div>

          <button type="submit" disabled={loading} className="mt-10 w-full bg-gray-900 text-white py-4 font-semibold uppercase tracking-wider text-sm hover:bg-gray-800 transition disabled:opacity-60" data-testid="login-submit">
            {loading ? t("auth.signin.loading") : t("auth.signin.action")}
          </button>

          <p className="mt-6 text-sm text-gray-500">
            {t("auth.nocount")} <Link to="/register" className="text-gray-900 font-semibold underline-offset-4 hover:underline">{t("auth.register")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
